module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_recruitment-26c5a66d8c9dea556a0541e449b8c7e3.svg";